module.exports = __webpack_public_path__ + "media/images/banner/japan-property/bnr_japan-property_horizon-d5580367587306e82475ca7bea9e214b.jpg";